import { useParams, useNavigate } from 'react-router-dom';
import ClientReportEditor from '../components/ClientReportEditor';

const ClientReportPage = () => {
  const { campaignId, reportId } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(`/campaigns/${campaignId}`);
    }
  };

  return (
    <ClientReportEditor
      campaignId={campaignId}
      reportId={reportId === 'new' ? undefined : reportId}
      onBack={handleBack}
    />
  );
};

export default ClientReportPage;
